import React from "react";

const AccountPagination = props => {
  const {
    currentPage,
    totalPages,
    perPage,
    totalAccounts,
    onPageChange,
    onPerPageChange,
  } = props;

  const startEntry = totalAccounts === 0 ? 0 : (currentPage - 1) * perPage + 1;
  const endEntry = Math.min(currentPage * perPage, totalAccounts);

  const handlePerPageChange = e => {
    const newPerPage = parseInt(e.target.value, 10);
    onPerPageChange(newPerPage);
  };

  const handlePageClick = page => {
    if (page >= 1 && page <= totalPages) {
      onPageChange(page);
    }
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const maxVisiblePages = 5;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage < maxVisiblePages - 1) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <span
          key={i}
          className={currentPage === i ? "active" : ""}
          onClick={() => handlePageClick(i)}
          style={{ cursor: "pointer" }}
        >
          {i}
        </span>,
      );
    }

    return pageNumbers;
  };

  return (
    <div className="sso-account-approval__pagination-wrapper">
      <div>
        <select value={perPage} onChange={handlePerPageChange}>
          <option value="10">10</option>
          <option value="25">25</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </select>{" "}
        entries per page • Showing {startEntry}–{endEntry} of {totalAccounts}{" "}
        accounts
      </div>
      <div className="sso-account-approval__pagination">
        <button
          className=""
          disabled={currentPage === 1}
          onClick={() => handlePageClick(currentPage - 1)}
        >
          <i className="fas fa-chevron-left"></i>
        </button>
        {renderPageNumbers()}
        <button
          className=""
          disabled={currentPage === totalPages}
          onClick={() => handlePageClick(currentPage + 1)}
        >
          <i className="fas fa-chevron-right"></i>
        </button>
      </div>
    </div>
  );
};

export default AccountPagination;
